namespace MainLoop {
	var inited:boolean = false;
	var lastTimeStamp:number = 0;
	var usePerfMonitor:boolean = false;
	export function init($usePerfMonitor:boolean):void {
		if (inited) {
			throw new PandaError('Attempt to init MainLoop that already inited');
		}
		usePerfMonitor = $usePerfMonitor;
		onEnterFrame = new Signal<(millisecondsDelta:number, millisecondsAbsolute:number)=>void>()
		if (usePerfMonitor) {
			PerfMonitor.init();
		}
		requestAnimationFrame(handler_animationFrame);
		lastTimeStamp = performance.now();
		inited = true;
	}

	export var onEnterFrame:Signal<(millisecondsDelta:number, millisecondsAbsolute:number)=>void> = null;

	
	function handler_animationFrame():void {
		let now = performance.now();
		let delta = now - lastTimeStamp;
		lastTimeStamp = now;
		// @if PERF
	 	PerfUtils.event('MainLoop', 'frame');
	 	// @endif

		onEnterFrame.emit(delta, now);
		requestAnimationFrame(handler_animationFrame);
		GlobalInstanceChecker.check();
		let after = performance.now();
		
		if (usePerfMonitor) { 
			PerfMonitor.enterFrameDispatchingTime(after - now);
		}
	}

	export function nextFrameCall(f:()=>void):void {
		let creationTimestamp = lastTimeStamp;
		let listener = MainLoop.onEnterFrame.addListener(()=>{
			if (lastTimeStamp != creationTimestamp) {
				MainLoop.onEnterFrame.removeListener(listener);
				f();
			}
		});
	}
}